/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_portalOfficeActivityLog_requestListPortalOfficeActivityLog } from '../models/api_portalOfficeActivityLog_requestListPortalOfficeActivityLog';
import type { api_portalOfficeActivityLog_responseListPortalOfficeActivityLog } from '../models/api_portalOfficeActivityLog_responseListPortalOfficeActivityLog';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PortalOfficeActivityLogService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List PortalOfficeActivityLog
     * アクティビティログ一覧を取得する。
     * @returns api_portalOfficeActivityLog_responseListPortalOfficeActivityLog responseListPortalOfficeActivityLog
     * @throws ApiError
     */
    public postPortalOfficeActivityLogList({
        body,
    }: {
        /**
         * requestListPortalOfficeActivityLog
         */
        body: api_portalOfficeActivityLog_requestListPortalOfficeActivityLog,
    }): CancelablePromise<api_portalOfficeActivityLog_responseListPortalOfficeActivityLog> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_activity_log/list',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
